import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { getAlert, setHideAlert } from "../../../features/alert/state/alertsSlice";
import type { IAlert } from "../../../model/model";
import type { InfoFrameStyle } from "../InfomationFrame/InformationFrame";
import InformationFrame from "../InfomationFrame/InformationFrame";

type AlertProps = {
  children?: React.ReactNode;
};

const Alert = ({ children = true }: AlertProps) => {
  const dispatch = useAppDispatch();

  const alertProps = useAppSelector(getAlert);
  const [currentAlert, setCurrentAlert] = useState<IAlert | null>();

  const hide = () => {
    dispatch(setHideAlert(currentAlert));
  };

  if (!alertProps) {
    hide();
  }

  useEffect(() => {
    if (alertProps.alertsQueue.length > 0) {
      const lastAlert = alertProps.alertsQueue[alertProps.alertsQueue.length - 1];

      if (lastAlert.id !== currentAlert?.id) {
        setCurrentAlert(lastAlert);
      }
    } else {
      if (!alertProps.alertsQueue.find((elt) => elt.id === currentAlert?.id)) {
        setCurrentAlert(null);
      }
    }
  }, [alertProps?.alertsQueue]);

  return (
    <>
      {currentAlert && (
        <InformationFrame
          className="w-full px-6 py-6 max-w-6xl mx-auto absolute w-2/3 left-[20%] transition-opacity z-[1000]"
          style={currentAlert.alertStyle as InfoFrameStyle}
          onClose={hide}
          withTimeout={true}
          customTimeoutInMs={currentAlert.customTimeoutInMs ? currentAlert.customTimeoutInMs : 0}
          showCloseButton={currentAlert.alertShowCloseButton}
        >
          {children}
          <div>{currentAlert.alertMsg}</div>
          <div className="text-xs italic">{currentAlert?.alertSubMsg}</div>
        </InformationFrame>
      )}
    </>
  );
};

export default Alert;
